import React from "react";

const CompanyPage = () => {
  return <div></div>;
};

export default CompanyPage;
